import { useMutation } from 'react-query'
import { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { t } from 'ttag'

import { showUserFeedback } from '../../../common/actions/showUserFeedback'

const FileUploadHandler = ({
  uploadUrl,
  onSuccess,
  onError,
  children,
  method = 'POST'
}) => {
  const [progress, setProgress] = useState(0)
  const reduxDispatch = useDispatch()
  const { mutate: uploadHandler, isLoading: isUploading } = useMutation(
    formData => {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest()

        xhr.responseType = 'json'

        xhr.onerror = event => {
          reject(event)
        }
        xhr.addEventListener('load', event => {
          const result = event.target.response

          if (xhr.status < 400) {
            resolve(result)
          } else {
            reject(result)
          }
        })
        xhr.upload.addEventListener('progress', event => {
          setProgress(Math.round((event.loaded / event.total) * 100))
        }) // event.loaded / event.total * 100 ; //event.lengthComputable
        xhr.open(method, uploadUrl)
        xhr.setRequestHeader('credentials', 'same-origin')
        xhr.send(formData)
      })
    },
    {
      onSuccess,
      onError: error => {
        if (onError) {
          onError(error)
        } else {
          reduxDispatch(
            showUserFeedback(t`An error occurred while uploading file.`, 'error')
          )
        }
      }
    }
  )

  return children({ uploadHandler, progress, isUploading })
}

FileUploadHandler.propTypes = {
  uploadUrl: PropTypes.string,
  onSuccess: PropTypes.func,
  method: PropTypes.oneOf(['POST', 'PUT'])
}

export { FileUploadHandler }
